import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  CARRIER,
  CITY,
  COMPANY_NAME,
  COUNTRY,
  LINE1,
  POSTAL_CODE,
  SHIP_TO,
  SHIPPING_METHOD
} from "APP_ROOT/constants";
import { PHYSICAL_ADDRESS } from "MODULES/companies/constants";
import { SHIP_TO_COMPANY_DISABLED } from "MODULES/SalesOrders/constants";
import { CUSTOMER, COMPANY, DROPSHIP, REPAIR_STATION } from "./shippingTypes";

export function validateShippingFields(
  shippingType,
  values,
  form,
  validateShippingMethod = true
) {
  const shipToType = values[`${shippingType}_type`];
  form.validate(`${shippingType}_type`).satisfies(rules.required);

  if (shipToType === COMPANY) {
    form
      .validate(
        `${shippingType}_company_id`,
        `${shippingType}_company_address_id`
      )
      .satisfies(rules.required);
  } else if (shipToType === DROPSHIP) {
    form.validateChild(`${shippingType}_shipping_address`, address => {
      address
        .validate(COMPANY_NAME, COUNTRY, LINE1, CITY, POSTAL_CODE)
        .satisfies(rules.required);
    });
  } else if (shipToType === CUSTOMER) {
    if (values.physical_address && values.physical_address.line1) {
      form.validateChild(PHYSICAL_ADDRESS, address => {
        address
          .validate(COUNTRY, LINE1, CITY, POSTAL_CODE)
          .satisfies(rules.required);
      });
    } else {
      form
        .validate(`${shippingType}_customer_address_id`)
        .satisfies(rules.required);
    }
  } else if (shipToType === REPAIR_STATION) {
    form
      .validate("repair_station_physical_address_id")
      .satisfies(rules.required);
  }

  if (validateShippingMethod) {
    form.validateChild(`${shippingType}_shipping_method`, method => {
      method.validate(CARRIER, SHIPPING_METHOD).satisfies(rules.required);
    });
  }
}

export function validateForShippingType(shippingType) {
  return values =>
    validator(values, form => {
      validateShippingFields(shippingType, values, form);
    });
}

export default function(values) {
  return validator(values, form => {
    validateShippingFields(SHIP_TO, values, form);

    form
      .validate(SHIP_TO_COMPANY_DISABLED)
      .satisfies(rules.shipToCompanyIsNoBiz);
  });
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/shared/FormSections/ShippingSection/validate.js